import { render } from "./SpendingHistory.vue?vue&type=template&id=abf519e6&scoped=true"
import script from "./SpendingHistory.vue?vue&type=script&lang=js"
export * from "./SpendingHistory.vue?vue&type=script&lang=js"

import "./SpendingHistory.vue?vue&type=style&index=0&id=abf519e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-abf519e6"]])

export default __exports__